"use strict";

document.addEventListener("DOMContentLoaded", function () {
  var LazyLoading = function () {
    var instance = new LazyLoad();

    function lazyBGImages() {
      var $bgImages = document.querySelectorAll('[data-bg]:not(.lazy)');

      if ($bgImages.length) {
        $bgImages.each(function () {
          $(this).addClass('lazy');
        });
      }

      instance.update();
    }

    function update() {
      lazyBGImages();
    }

    lazyBGImages();
    return {
      update: update
    };
  }();

  var SmoothScroll = function () {
    var $anchorLinks = $('a[href^="#"]').not('a[href="#"]');
    $('a[href="#"]').click(function (e) {
      e.preventDefault();
      return;
    });

    function goTo(target) {
      if (target === "" || !$(target).length) {
        return;
      }

      var scrollPos = typeof target === 'number' ? target : $(target).offset().top;

      if (window.innerWidth >= 720) {
        scrollPos -= $('header').outerHeight();
      } else {
        scrollPos -= $('header').outerHeight() * 2;
      }

      $('html, body').stop().animate({
        'scrollTop': scrollPos - 32
      }, 1200, 'swing', function () {
        if (typeof target === 'string') {
          if (window.location.hash) {// window.location.hash = target;
          }
        }
      });
    }

    if (window.location.hash) {
      setTimeout(function () {
        goTo(window.location.hash);
      }, 500);
    }

    if ($anchorLinks.length) {
      $anchorLinks.on('click', function (e) {
        if (!$("#" + this.hash.replace('#', '')).length) {
          return;
        }

        e.preventDefault();
        goTo(this.hash);
      });
    }

    return {
      to: goTo
    };
  }(); //Global function to toggle simple accordions


  var Accordions = function () {
    var $accordions = $('.accordion');

    if (!$accordions.length) {
      return;
    }

    $accordions.each(function () {
      if ($(this).hasClass('active')) {
        $(this).find('.accordion__content').show();
      }
    });
    $accordions.find('.accordion__trigger').click(function (e) {
      var $this = $(this);
      var $accordion = $this.parent();
      var $content = $accordion.find('.accordion__content');
      var $siblings = $accordion.siblings();

      if ($accordion.hasClass('active')) {
        $accordion.removeClass('active');
        $content.slideUp('fast');
      } else {
        $accordion.addClass('active');
        $siblings.removeClass('active').find('.accordion__content').slideUp('fast');
        $content.slideDown('fast');
      }
    });
  }();

  AOS.init();

  function addSwiperHTML($el) {
    $el.addClass('swiper');
    $el.children().addClass('swiper-slide');
  }

  function KlaviyoSubscribe(listID, email, phone, source, $form) {
    $.ajax({
      type: "POST",
      url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
      data: {
        g: listID,
        email: email,
        phone_number: phone,
        sms_consent: true,
        $fields: "$source",
        $source: source
      },
      contentType: "application/x-www-form-urlencoded",
      error: function error(err) {
        console.log("Could not connect to Klaviyo.");
        console.log(err);
      },
      success: function success(data) {
        console.log('success');
        console.log(data);
        $form.after('<p>Thank You For Subscribing!</p>');
        $form.hide();
      }
    });
  }

  var header = function () {
    var $menubtn = $('.menu-burger');
    var $mobMenu = $('.gheader__mobile-menu');
    $menubtn.click(function () {
      $menubtn.toggleClass('active');
      $mobMenu.toggleClass('active');
      $('body').toggleClass('no-scroll');
    });
    $mobMenu.find('li.haslinks > a').click(function (e) {
      e.preventDefault();
      var $this = $(this);
      $this.toggleClass('active');
      $this.next().slideToggle();
    }); // $mobMenu.find('.search-icon').click(function(){
    // 	$mobMenu.find('.search-bar').slideToggle();
    // });

    var $icons = $('.gheader__icons');
    $icons.find('.search-icon,.close-search').click(function () {
      $icons.find('.search-bar').toggleClass('active');
    });
    var $megamenuTrigger = $('.gheader__menu [data-menu]');
    var $megamenus = $('.mega-menu');
    var $megamenuLinks = $('.mega-menu__list li');

    function megaMenuClick($this) {
      var hover = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if ($this.data('menu')) {
        var menu = $this.data('menu');
        var $menu = $megamenus.filter('[data-menu="' + menu + '"]'); // console.clear();
        // console.log(1);

        console.log($menu);
        console.log($menu.hasClass('active'));

        if ($menu.hasClass('active')) {
          // console.log(2);
          if (!hover) {
            // console.log(3);
            $megamenus.removeClass('active');
            $('body').removeClass('blur');
            $this.removeClass('active');
          }
        } else {
          // console.log(4);
          $megamenus.removeClass('active');
          $megamenuTrigger.removeClass('active');
          $menu.addClass('active');
          $this.addClass('active');
          $('body').addClass('blur');
        }
      } else {
        $megamenus.removeClass('active');
        $megamenuTrigger.removeClass('active');
        $('body').removeClass('blur');
      }
    } // $megamenuTrigger.click(function(e){
    // 	e.preventDefault();
    // 	megaMenuClick($(this));
    // });


    $('.gheader__menu a').mouseenter(function () {
      megaMenuClick($(this), true);
    });
    $('.blur-overlay').mouseenter(function () {
      megaMenuClick($(this), true);
    }); // $megamenuTrigger.mouseleave(function(){
    // 	megaMenuClick($(this),true);
    // });
    // $megamenuTrigger.click(function(){
    // 	megaMenuClick($(this),true);
    // });

    $megamenuLinks.hover(function () {
      var $this = $(this);
      var $menu = $this.closest('.mega-menu__list');

      if ($menu.hasClass('hover-images')) {
        if ($this.data('image') != undefined) {
          $menu.find('.hover-image').css('background-image', 'url("' + $this.data('image') + '")');
        }
      }
    });
    $megamenus.each(function () {
      var $menu = $(this);
      var $links = $menu.find('.mega-menu__list li');

      if ($menu.find('.mega-menu__list').hasClass('hover-images')) {
        $links.each(function () {
          var $this = $(this);

          if ($this.data('image') != undefined) {
            $menu.find('.hover-image').css('background-image', 'url("' + $this.data('image') + '")');
            return false;
          }
        });
      }
    });
  }();

  var faqTemplate = function () {
    if (!$('.faq-template').length) {
      return;
    }

    function faqCategory(cat) {
      $('.faq-template__content').removeClass('active');
      $('.faq-template__nav button').removeClass('active');
      $('.faq-template__content[data-cat="' + cat + '"]').addClass('active');
      $('.faq-template__nav button[data-cat="' + cat + '"]').addClass('active');
    }

    $('.faq-template__nav button').on('click', function (e) {
      faqCategory($(this).data('cat'));
    });
    $('.faq-template__nav select').on('change', function () {
      faqCategory($(this).val());
    });
  }();

  var blogTemplate = function () {
    $('.blog__filters select').on('change', function (e) {
      e.preventDefault();
      var $this = $(this);
      var url = $this.val();
      window.location = url;
    });
  }();

  var footerSubscribe = function () {
    $('.gfooter form').submit(function (e) {
      e.preventDefault();
      var $this = $(this);
      var $email = $this.find('[name="email"]');
      var $phone = $this.find('[name="phone"]');

      if ($email.val() != '' && $phone.val() != '') {
        KlaviyoSubscribe('XqQFkZ', $email.val(), $phone.val(), 'Website Footer', $this);
      }
    });
  }();

  var QtyInput = function () {
    var $qtyInputs = $('.qty-input');

    if (!$qtyInputs.length) {
      return;
    }

    var $inputs = $qtyInputs.find('.product-qty');
    var $countBtn = $qtyInputs.find('.qty-count');
    $inputs.each(function () {
      var min = 1;

      if ($(this).data('min') != undefined) {
        min = parseInt($(this).data('min'));
      }

      if ($(this).val() > min) {
        $(this).siblings('.qty-count--minus').attr('disabled', false);
      } else {}
    });
    $('body').on('change', '.qty-input .product-qty', function () {
      var $this = $(this);
      var $minusBtn = $this.siblings('.qty-count--minus');
      var qty = parseInt($this.val());
      var min = 1;

      if ($this.data('min') != undefined) {
        min = parseInt($this.data('min'));
      }

      if (isNaN(qty) || qty <= min) {
        $this.val(min);
        $minusBtn.attr('disabled', true);
      } else {
        $minusBtn.attr('disabled', false);
        $this.val(qty);
      }
    });
    $('body').on('click', '.qty-count', function () {
      var operator = this.dataset.action;
      var $this = $(this);
      var $input = $this.siblings('.product-qty');
      var qty = parseInt($input.val());
      var min = 1;

      if ($input.data('min') != undefined) {
        min = parseInt($input.data('min'));
      }

      if (operator == 'add') {
        qty += 1;

        if (qty == min + 1) {
          $this.siblings('.qty-count--minus').attr('disabled', false);
        }
      } else {
        qty = qty <= min ? min : qty -= 1;

        if (qty == min) {
          $this.attr('disabled', true);
        }
      }

      $input.val(qty).trigger('change');
    });
  }();

  var featProductCollection = function () {
    var $sliders = $('.feat-prod-col__tab');

    if (!$sliders.length) {
      return;
    }

    var $nav = $('.feat-prod-col__nav button');
    $nav.click(function () {
      var $this = $(this);
      $nav.removeClass('active');
      $this.addClass('active');
      var target = $this.data('tab');
      $sliders.filter('.active').fadeOut(function () {
        $sliders.removeClass('active');
        $sliders.filter('[data-tab="' + target + '"]').fadeIn().addClass('active');
      });
    });

    function checkSwiper($slider) {
      // console.log('checking slider');
      $slider.slideTo(0);

      if ($slider.params.slidesPerView > $slider.slides.length) {
        $($slider.$el).addClass('center');
      } else {
        $($slider.$el).removeClass('center');
      }
    }

    $sliders.each(function () {
      var $this = $(this);
      var slideNum = $this.children().length; // addSwiperHTML($this);

      var $slider = new Swiper($this[0], {
        // createElements:true,
        slidesPerView: 1.25,
        centeredSlides: true,
        centeredSlidesBounds: true,
        loop: true,
        navigation: {
          enabled: true,
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          disabledClass: 'opacity-0'
        },
        initialSlide: 1,
        breakpoints: {
          960: {
            initialSlide: 1,
            slidesPerView: 3,
            loop: false,
            navigation: {
              enabled: true,
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
              disabledClass: 'opacity-0'
            }
          },
          1200: {
            initialSlide: 1,
            slidesPerView: 4,
            loop: false,
            navigation: {
              enabled: true,
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
              disabledClass: 'opacity-0'
            }
          }
        }
      });
      $slider.on('resize', function () {
        // console.log('resize');
        checkSwiper($slider);
      });
    });
  }();

  var relatedProducts = function () {
    var $sliders = $('.related-products__loop');

    if (!$sliders.length) {
      return;
    }

    $sliders.each(function () {
      var $this = $(this);
      addSwiperHTML($this);
      var $slider = new Swiper($this[0], {
        createElements: true,
        slidesPerView: 1.25,
        centeredSlides: true,
        loop: true,
        navigation: true,
        breakpoints: {
          960: {
            slidesPerView: 3,
            loop: false,
            centeredSlides: false
          },
          1200: {
            slidesPerView: 4,
            loop: false,
            centeredSlides: false
          }
        }
      });
    });
  }();

  var beforeAfter = function () {
    var $sliders = $('.before-after__loop');

    if (!$sliders.length) {
      return;
    }

    $sliders.each(function () {
      var $this = $(this);
      addSwiperHTML($this);
      var $slider = new Swiper($this[0], {
        createElements: true,
        slidesPerView: 1,
        centeredSlides: false,
        loop: false,
        navigation: true,
        spaceBetween: 16,
        breakpoints: {
          960: {
            slidesPerView: 2
          }
        }
      });
    });
  }();

  var testimonials = function () {
    var $sliders = $('.testimonials__loop');

    if (!$sliders.length) {
      return;
    }

    $sliders.each(function () {
      var $this = $(this);
      addSwiperHTML($this);
      var $slider = new Swiper($this[0], {
        createElements: true,
        slidesPerView: 1,
        centeredSlides: false,
        loop: true,
        navigation: true,
        spaceBetween: 16
      });
    });
  }();

  var productImages = function () {
    var $sliders = $('.mproduct__main-gallery');

    if (!$sliders.length) {
      return;
    } // addSwiperHTML($sliders);


    var slider = new Swiper($sliders[0], {
      // createElements:true,
      slidesPerView: 1,
      centeredSlides: false,
      loop: false,
      spaceBetween: 16,
      navigation: true // breakpoints: {
      // 	1200: {
      // 		navigation:false,
      // 	}
      // }

    });
    var $sliders2 = $('.mproduct__thumb-gallery'); // addSwiperHTML($sliders2);

    var slider2 = new Swiper($sliders2[0], {
      direction: 'vertical',
      // createElements:true,
      centeredSlides: false,
      loop: false,
      slidesPerView: 4,
      spaceBetween: 16,
      slideToClickedSlide: true,
      breakpoints: {
        1200: {
          slidesPerView: 5
        },
        1400: {
          slidesPerView: 6
        }
      }
    });
    slider2.on('click', function () {
      slider.slideTo(slider2.clickedIndex);
    });
    slider.on('activeIndexChange', function () {
      // console.log(slider.activeIndex);
      slider2.slideTo(slider.activeIndex);
    });
  }();

  var latestPosts = function () {
    var $sliders = $('.latest-posts__loop');

    if (!$sliders.length) {
      return;
    }

    $sliders.each(function () {
      var $this = $(this);
      addSwiperHTML($this);
      var $slider = new Swiper($this[0], {
        createElements: true,
        slidesPerView: 1.25,
        centeredSlides: false,
        loop: true,
        spaceBetween: 16,
        breakpoints: {
          500: {
            slidesPerView: 1.75
          },
          960: {
            slidesPerView: 3,
            loop: false,
            centeredSlides: false
          }
        }
      });
    });
  }();

  var featCollections = function () {
    var $sliders = $('.featured-collections__loop');

    if (!$sliders.length) {
      return;
    }

    $sliders.each(function () {
      var $this = $(this);
      addSwiperHTML($this);
      var $slider = new Swiper($this[0], {
        createElements: true,
        slidesPerView: 1.5,
        loop: true,
        spaceBetween: 8,
        navigation: true,
        lazy: {
          loadPrevNext: true
        },
        breakpoints: {
          960: {
            slidesPerView: 2.5
          },
          1200: {
            slidesPerView: 3
          }
        }
      });
    });
  }();

  var marqueeSliders = function () {
    var $sliders = $('.marquee__slider');

    if (!$sliders.length) {
      return;
    }

    document.fonts.ready.then(function () {
      $sliders.each(function () {
        var $slider = $(this);
        var $items = $slider.find('.marquee__item');
        var loop = horizontalLoop($items, {
          paused: false,
          repeat: -1,
          speed: .5
        });
      });
    });
  }(); // var cartPage = (function(){
  // 	function updateCart(data){
  // 		// console.log(data);
  // 		$.ajax({
  // 			url: '/cart/update.js',
  // 			type: 'POST',
  // 			data: data,
  // 			success: function(response){
  // 				var response = JSON.parse(response);
  // 				// console.log(response);
  // 				updateCartTotals(response)
  // 			},
  // 			error: function(response){
  // 				console.log(response);
  // 			}
  // 		});
  // 	}
  // 	function updateCartTotals(data){
  // 		$('.total-price').text( Shopify.formatMoney(data.total_price) );
  // 		$('.product-row').each(function(){
  // 			var $this = $(this);
  // 			var id = $this.data('id');
  // 			$('.cart-count__count').text(data.item_count);
  // 			$.each(data.items, function(i,item){
  // 				if( item.variant_id == id ){
  // 					$this.find('.product-row__title').text( item.title );
  // 					if( item.quantity > 1 ){
  // 						$this.find('.product-row__title').append(' (x'+item.quantity+')');
  // 					}
  // 					// $this.find('.product-row__price').text( Shopify.formatMoney(item.line_price) );
  // 					return false;
  // 				}
  // 			});
  // 		});
  // 	}
  // 	$('.cart-card__quantity input').change(function(e){
  // 		var $this = $(this);
  // 		var $parent = $this.closest('.cart-card');
  // 		var quantity = parseInt($this.val());
  // 		var variant = $parent.data('id');
  // 		var items = {updates: {[variant]: quantity}};
  // 		updateCart(items);
  // 	});
  // }());
  // var upsells = (function(){
  // 	var $sliders = $('.atc-popup__upsells');
  // 	if( !$sliders.length ){ return; }
  // 	$sliders.each(function(){
  // 		var $this = $(this);
  // 		addSwiperHTML($this);
  // 		var $slider = new Swiper($this[0],{
  // 			createElements:true,
  // 			slidesPerView: 1,
  // 			centeredSlides: false,
  // 			loop:false,
  // 			navigation:true,
  // 			spaceBetween: 16,
  // 		});
  // 	});
  // }());


  var productPage = function () {
    var $check = $('.product-options-check');
    var $select = $check.find('.product-options-check__select');
    var $planSelect = $check.find('[name="selling_plan"]');
    var $planOption = $check.find('.custom-recharge__option input');
    var $subscriptionPlan = $check.find('.custom-recharge__option--subscription');

    function updatePrice($select, $planSelect) {
      var price = $planSelect.closest('.atc-form').data('price');

      if ($select) {
        var $options = $select.find('option');
        var $option = $options.filter(':selected');
        price = $option.data('price');
      }

      var $plan = $planSelect.filter(':checked');
      $('.product-price__main').text(Shopify.formatMoney(price));
      $('.custom-recharge__price').text(Shopify.formatMoney(price));

      if ($plan.length) {
        if ($plan.val().length) {
          var discount = $plan.data('discount');
          var difference = price / 100 * discount;
          price = price - difference;
          $('.product-price__main').text(Shopify.formatMoney(price));
        }
      }
    }

    $select.change(function () {
      updatePrice($select, $planSelect);
    }); // $planSelect.change(function(){
    // 	if( !$select.length ){
    // 		$select = false;
    // 	}
    // 	updatePrice($select,$planSelect);
    // });

    $('body').on('change', '.custom-recharge__option input[name="selling_plan"]', function () {
      var $this = $(this);

      if (!$select.length) {
        $select = false;
      }

      updatePrice($select, $planSelect); // if( !$this.is(":checked") ){
      // 	$planOption.prop('checked',false);
      // 	$this.prop('checked',true);

      var clone = $subscriptionPlan.clone();
      $subscriptionPlan.empty();

      if ($this.val() == '') {
        $(clone).find('input').attr('name', 'selling_plan');
        $(clone).find('select').removeAttr('name');
        $subscriptionPlan.append(clone.html());
      } else {
        $(clone).find('input').removeAttr('name');
        $(clone).find('select').attr('name', 'selling_plan');
        $subscriptionPlan.append(clone.html());
        $subscriptionPlan.find('input').prop('checked', true);
      } // }

    }); // $planOption.click(function(){
    // 	var $this = $(this);
    // 	var $plan = $this.find('input[type="radio"]');
    // 	var clone = $subscriptionPlan.clone();
    // 	if( $plan.val() == '' ){
    // 		console.log(1);
    // 		$subscriptionPlan.empty();
    // 		$subscriptionPlan.append( clone.html() );
    // 	}else{
    // 		console.log(2);
    // 		$subscriptionPlan.empty();
    // 		$subscriptionPlan.append( clone.html() );
    // 	}
    // });
  }(); // var ajaxCart = (function(){
  // 	var $atcForm = $('.atc-form');
  // 	function handlePopupClose(){
  // 		$('.atc-popup').removeClass('active');
  // 		$('.mega-menu').removeClass('active')
  // 		$('body').removeClass('blur');
  // 		$('[data-menu].active').removeClass('active');
  // 	}
  // 	$('.blur-overlay').click(function(){
  // 		// console.log('click');
  // 		handlePopupClose();
  // 	});
  // 	$('.close-atc-popup').click(function(){
  // 		handlePopupClose();
  // 	});
  // 	function updateCart($form,res){
  // 		var $popItem = $('.atc-popup__item');
  // 		$popItem.find('img').attr('src',res.featured_image.url);
  // 		$popItem.find('.name').text(res.title);
  // 		$popItem.find('.price').text(Shopify.formatMoney(res.price));
  // 		$popItem.find('.qty__count').text(res.quantity);
  // 		$popItem.closest('.atc-popup').addClass('active');
  // 		$('body').addClass('blur');
  // 		// $('body').addClass('no-scroll');
  // 		// clearTimeout(closePopup);
  // 		// var closePopup = setTimeout(function(){
  // 			// handlePopupClose();
  // 		// },10000);
  // 		$.getJSON( "/cart.js", function( data ) {
  // 			console.log(data);
  // 			$('.cart-count__count').text(data.item_count);
  // 		});
  // 	}
  // 	$('body').on('submit','.atc-form',function(e){
  // 		e.preventDefault();
  // 		var $form = $(this);
  // 		console.log('ajax atc');
  // 		$.ajax({
  // 			url:'/cart/add.js',
  // 			type:'POST',
  // 			data: $form.serialize(),
  // 			complete: function(jqXHR,response) {
  // 				var resText = JSON.parse(jqXHR.responseText);
  // 				console.log(resText);
  // 			    if( jqXHR.status == 200){
  // 					updateCart($atcForm, resText);
  // 				}else{
  // 				   if( resText.indexOf( "You can't add more" ) > -1 ){
  // 					   console.log('You attempted to add more of this item than we have in stock, please select a lower quantity and try again.');
  // 				   }else if( resText.indexOf( "are in your cart" ) > -1 ){
  // 					   console.log('The remaining inventory of this product option is already in your cart.');
  // 				   }else{
  // 					   console.log('Somethihg went wrong trying to add to cart ' + response);
  // 				   }
  // 				}
  // 		   }
  // 		});
  // 	});
  // }());


  var adjustItems = function () {
    var $header = $('.gheader');
    var $window = $(window);
    var $atcPop = $('.atc-popup');
    $window.resize(function () {
      var headHeight = $header.outerHeight();
      var windowHeight = $window.outerHeight();
      $atcPop.css({
        height: windowHeight - headHeight,
        top: headHeight
      });
    });
    $window.trigger('resize');
  }();

  AOS.refresh();
});